import {helpers, required} from "@vuelidate/validators";
import { insertUserNetwork } from '@/services/networkService.js';

export class RegisterNetworkModel {
    constructor() {
        this.entityId = null;
        this.newNetworkName = null;
        this.newNetworkId = null;
        this.newMarketType = null;
    }

    static getValidationRules() {
        return {
            newNetworkName: { required: helpers.withMessage('Network Name is required', required) },
            newNetworkId: { required: helpers.withMessage('Network ID is required', required) },
            newMarketType: { required: helpers.withMessage('Network Market Type is required', required) },
        };
    }

    static getPBMValidationRules() {
        return {
            newNetworkName: { required: helpers.withMessage('Network Name is required', required) },
        };
    }

    async save() {
        try {
            console.log('Check RegisterNetworkModle save function paramters: ', this.entityId,this.newNetworkName,this.newNetworkId,this.newMarketType);
            return await insertUserNetwork(this.entityId,this.newNetworkName,this.newNetworkId,this.newMarketType);
        } catch (error) {
            console.error('Error saving network:', error);
            throw error;  // Or return a custom error message if needed
        }
    }

}